const LS_PREFIX = 'aiSupportedMarkingIntro.dontShowAgain';
const SESSION_DISMISS_PREFIX = 'aiSupportedMarkingIntro.dismissedForWorkspaceVisit';

export const getLoggedInUserId = (): number | undefined => {
    const userId = Number(window.userId);
    return userId > 0 ? userId : undefined;
};

export const getDontShowAgainStorageKey = (userId: number, assessmentRunId: number): string => (
    `${LS_PREFIX}.${userId}.${assessmentRunId}`
);

export const readDontShowAgainForUserAndAssessment = (
    userId?: number,
    assessmentRunId?: number,
): boolean => {
    if (!(userId > 0 && assessmentRunId > 0)) {
        return false;
    }
    try {
        return localStorage.getItem(getDontShowAgainStorageKey(userId, assessmentRunId)) === 'true';
    } catch (e) {
        console.error('Could not read AI marking intro preference', e);
        return false;
    }
};

export const writeDontShowAgainForUserAndAssessment = (
    userId: number | undefined,
    assessmentRunId: number | undefined,
    value: boolean,
): void => {
    if (!(userId > 0 && assessmentRunId > 0)) {
        return;
    }
    try {
        localStorage.setItem(getDontShowAgainStorageKey(userId, assessmentRunId), String(value));
    } catch (e) {
        console.error('Could not persist AI marking intro preference', e);
    }
};

export const getDismissedForWorkspaceVisitKey = (userId: number, assessmentRunId: number): string => (
    `${SESSION_DISMISS_PREFIX}.${userId}.${assessmentRunId}`
);

/** Set when Dismiss or the cross is used. Cleared when the marking workspace is left. */
export const readDismissedForWorkspaceVisit = (userId?: number, assessmentRunId?: number): boolean => {
    if (!(userId > 0 && assessmentRunId > 0)) {
        return false;
    }
    try {
        return sessionStorage.getItem(getDismissedForWorkspaceVisitKey(userId, assessmentRunId)) === 'true';
    } catch (e) {
        console.error('Could not read AI marking intro workspace dismissal', e);
        return false;
    }
};

export const writeDismissedForWorkspaceVisit = (userId?: number, assessmentRunId?: number): void => {
    if (!(userId > 0 && assessmentRunId > 0)) {
        return;
    }
    try {
        sessionStorage.setItem(getDismissedForWorkspaceVisitKey(userId, assessmentRunId), 'true');
    } catch (e) {
        console.error('Could not persist AI marking intro workspace dismissal', e);
    }
};

export const clearDismissedForWorkspaceVisit = (userId?: number, assessmentRunId?: number): void => {
    if (!(userId > 0 && assessmentRunId > 0)) {
        return;
    }
    try {
        sessionStorage.removeItem(getDismissedForWorkspaceVisitKey(userId, assessmentRunId));
    } catch (e) {
        console.error('Could not clear AI marking intro workspace dismissal', e);
    }
};
